import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { OnboardingLayout, OnboardingCard, OnboardingButton } from "@/components/onboarding-layout";

export const Route = createFileRoute("/onboarding/waitlist/pending")({
  component: WaitlistPendingPage,
});

function WaitlistPendingPage() {
  const { t } = useTranslation(["pages", "common"]);
  const navigate = useNavigate();

  const handleReturn = () => {
    navigate({ to: "/onboarding/activation" });
  };

  return (
    <OnboardingLayout showLogo={false}>
      <OnboardingCard
        width="412px"
        height="509px"
        className="p-6 sm:p-8 md:p-[40px] rounded-[12px] sm:rounded-[18px] md:rounded-[24px] bg-waitlist-gradient"
      >
        <div className="h-full flex flex-col justify-between">
          {/* Title and Status Icon */}
          <div className="flex flex-col items-center text-center space-y-4 sm:space-y-6 pt-4 sm:pt-8">
            <div className="space-y-4 sm:space-y-6">
              <h2 className="text-2xl sm:text-3xl md:text-[32px] font-medium text-black leading-tight">
                {t("pages:onboarding.waitlist.success.title")}
              </h2>
              <img
                src="/waitlist-pending.png"
                alt="Waitlist pending"
                className="w-20 sm:w-28 md:w-[125px] h-auto mx-auto"
              />
            </div>
            <p className="text-sm sm:text-base md:text-[16px] leading-relaxed">
              <span className="text-black font-semibold">
                {t("pages:onboarding.waitlist.success.subtitle")}
              </span>
              <br />
              <span className="text-[#666666] text-xs sm:text-[12px]">
                {t("pages:onboarding.waitlist.success.desc")}
              </span>
            </p>
          </div>

          {/* Return Button - Full width, centered */}
          <div className="flex justify-center">
            <OnboardingButton onClick={handleReturn} className="w-full">
              {t("pages:onboarding.waitlist.success.return")}
            </OnboardingButton>
          </div>
        </div>
      </OnboardingCard>
    </OnboardingLayout>
  );
}
